import { render, staticRenderFns } from "./EditSettingNotification.vue?vue&type=template&id=366d6ade"
import script from "./EditSettingNotification.vue?vue&type=script&lang=js"
export * from "./EditSettingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports